import * as React from "react";
const SvgFiRrFanTable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.5 9.5A9.5 9.5 0 0 0 12 0a9.5 9.5 0 0 0-9.5 9.5c0 4.9 3.73 8.945 8.5 9.446V22H7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-4v-3.054c4.77-.502 8.5-4.546 8.5-9.446m-4.142 5.239c-.927-.929-2.234-2.565-3.23-3.914 1.64.348 3.692.909 4.87 1.352a7.5 7.5 0 0 1-1.64 2.562M19.5 9.5q-.001.365-.037.722c-1.642-.588-4.198-1.251-5.976-1.554.677-1.608 1.562-4.081 1.96-5.822A7.5 7.5 0 0 1 19.5 9.5M12 2c.533 0 1.052.058 1.553.164-.252 1.206-.932 3.258-1.553 4.859-.621-1.602-1.302-3.654-1.553-4.86A7.5 7.5 0 0 1 12 1.999zM4.5 9.5c0-2.893 1.649-5.403 4.053-6.654.397 1.74 1.282 4.214 1.96 5.822-1.778.303-4.335.967-5.977 1.554A8 8 0 0 1 4.5 9.5m.502 2.676c1.179-.442 3.23-1.003 4.87-1.352-.996 1.349-2.303 2.985-3.23 3.914a7.5 7.5 0 0 1-1.64-2.562M12 17a7.45 7.45 0 0 1-3.769-1.026c1.24-1.28 2.776-3.277 3.769-4.68.993 1.402 2.529 3.399 3.769 4.68A7.45 7.45 0 0 1 12 17"
    />
  </svg>
);
export default SvgFiRrFanTable;
